import { TranslateUtils } from "./translate.utils";

export class EnumsUtils {
  /**
   * Retourne le libellé d'une valeur d'enum.
   * @param enumerationLibelle — soit un enum Libelle (legacy), soit un préfixe de traduction (ex: 'enums.commande_etat')
   */
  static libelleFromEnum(
    enumeration: any,
    enumerationLibelle: any,
    val: any,
  ): string {
    if (!enumeration || !enumerationLibelle || !val) {
      return "";
    }
    const keyFromValue = this.getKeyFromValue(enumeration, val);
    if (!keyFromValue) {
      return "";
    }
    // Si c'est un préfixe de traduction (string), utiliser le système i18n
    if (typeof enumerationLibelle === "string") {
      return TranslateUtils.translate(`${enumerationLibelle}.${keyFromValue}`);
    }
    return enumerationLibelle[keyFromValue] ?? "";
  }

  static getKeyFromValue(enumeration: any, val: any): string {
    const keyFromValue = Object.keys(enumeration).filter(
      (key) => enumeration[key] === val,
    ) as string[];
    if (keyFromValue && keyFromValue.length > 0) {
      return keyFromValue[0];
    }
    return undefined;
  }

  static enumToArray(data: Object) {
    const keys = [];
    for (const item in data) {
      keys.push({ key: item, value: data[item] });
    }
    return keys;
  }
}
